// removed by extract-text-webpack-plugin
module.exports = {"container":"_1PP8NY10JA66y8TbznMMf1"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/PrepareTemplate/Field/Menu/TextSize/styles.css
// module id = 3138
// module chunks = 0